import Rails from '@rails/ujs'
import { Turbo } from '@hotwired/turbo-rails'
import 'flowbite/dist/flowbite.turbo'

import LocalTime from 'local-time'
import '~/channels/index.js'
import '~/controllers/index.js'

import '~/stylesheets/application.scss'

// ADDED: Import page editor services for inline toolbar access
import {
  SaveQueue,
  QueueStatus,
  DraftManager,
  ConnectionMonitor,
  ConnectionStatus,
  ConflictResolver,
  ConflictAction,
  EditorEvents,
  trackEditorEvent,
  ToastManager,
  ChangeIndicator,
  RichTextToolbar,
  KeyboardShortcuts,
  SHORTCUTS,
  LockManager, // ADDED: Phase 4 Collaboration
  PresenceManager
} from '~/javascript/services/page_editor/index.js'

window.Rails = Rails
window.Turbo = Turbo

// ADDED: Expose page editor services to inline toolbar scripts
// Usage: window.PageEditor.SaveQueue, window.PageEditor.DraftManager, etc.
window.PageEditor = {
  SaveQueue,
  QueueStatus,
  DraftManager,
  ConnectionMonitor,
  ConnectionStatus,
  ConflictResolver,
  ConflictAction,
  EditorEvents,
  trackEditorEvent,
  ToastManager,
  ChangeIndicator,
  RichTextToolbar,
  KeyboardShortcuts,
  SHORTCUTS,
  LockManager, // ADDED: Phase 4 Collaboration
  PresenceManager
}

LocalTime.start()

// Export Vue component mounting helper for inline scripts
window.mountBlockBackgroundEditor = async function mountBlockBackgroundEditor(mountEl, props) {
  try {
    const [{ createApp }, { default: BlockBackgroundEditor }] = await Promise.all([
      import('vue'),
      import('~/javascript/components/admin/page_editor/BlockBackgroundEditor.vue')
    ])

    const app = createApp(BlockBackgroundEditor, props)
    app.mount(mountEl)
    console.log('[Background] Vue component mounted successfully')
    return app
  } catch (err) {
    console.error('[Background] Failed to load Vue component:', err)
    throw err
  }
}
